import { defineStore } from 'pinia';
import api from '@/api';

export const useMeasureTypeStore = defineStore('measureType', {
  state: () => ({
    measureTypes: [],
    measureType: null,
    lookups: [],
    loading: false,
    error: null
  }),

  getters: {
    getMeasureTypes: (state) => state.measureTypes,
    getMeasureType: (state) => state.measureType,
    getLookups: (state) => state.lookups,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  actions: {
    async fetchMeasureTypes(params = {}) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.measureType.getMeasureTypes(params);
        this.measureTypes = resp.data || [];
      } catch (e) {
        this.error = e;
        this.measureTypes = [];
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async fetchMeasureType(id) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.measureType.getMeasureType(id);
        this.measureType = resp.data;
      } catch (e) {
        this.error = e;
        this.measureType = null;
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async fetchLookups() {
      this.error = null;
      try {
        const resp = await api.measureType.getMeasureTypeLookups();
        this.lookups = resp.data || [];
      } catch (e) {
        this.error = e;
        this.lookups = [];
        throw e;
      }
    },

    clearMeasureTypes() {
      this.measureTypes = [];
    },

    clearMeasureType() {
      this.measureType = null;
    },

    clearLookups() {
      this.lookups = [];
    },

    clearError() {
      this.error = null;
    },

    clearAll() {
      this.clearMeasureTypes();
      this.clearMeasureType();
      this.clearLookups();
      this.clearError();
    }
  }
});
